import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=d5cf36c0&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5cf36c0')) {
      api.createRecord('d5cf36c0', component.options)
    } else {
      api.reload('d5cf36c0', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=d5cf36c0&", function () {
      api.rerender('d5cf36c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bANi4mp1Z0f0/JS/comp/openstreetmap.vue"
export default component.exports